<template>
  <w-spoiler summary="Instrukcja wypełnienia tabeli w części D formularza">
    <div class="row form-group">
      <div class="col-12">
        <p>
          Należy podać informacje o dotychczas otrzymanej pomocy, w odniesieniu do tych samych kosztów kwalifikujących
          się do objęcia pomocą, na pokrycie których udzielana będzie pomoc de minimis. Na przykład, jeżeli podmiot
          ubiegający się o pomoc de minimis otrzymał w przeszłości pomoc w związku z realizacją inwestycji, należy
          wykazać jedynie pomoc przeznaczoną na te same koszty kwalifikujące się do objęcia pomocą, na pokrycie których
          ma być udzielona pomoc de minimis.
        </p>

        <ol>
          <li>
            Dzień udzielenia pomocy (kol. 1) - należy podać dzień udzielenia pomocy w rozumieniu art. 2 pkt 11 ustawy z
            dnia 30 kwietnia 2004 r. o postępowaniu w sprawach dotyczących pomocy publicznej.
          </li>

          <li>
            Podmiot udzielający pomocy (kol. 2) - należy podać pełną nazwę i adres podmiotu, który udzielił pomocy. W
            przypadku gdy podmiot uzyskał pomoc na podstawie aktu normatywnego, który uzależnia nabycie prawa do
            otrzymania pomocy wyłącznie od spełnienia przesłanek w nim określonych, bez konieczności wydania decyzji
            albo zawarcia umowy, należy pozostawić to miejsce niewypełnione.
          </li>

          <li>
            Podstawa prawna otrzymanej pomocy (kol. 3a i 3b) <br />
            <b>Uwaga:</b> istnieją następujące możliwości łączenia elementów tworzących podstawę prawną otrzymanej
            pomocy, które należy wpisać w poszczególnych kolumnach tabeli w sposób przedstawiony poniżej. <br />

            <table width="100%" border="1">
              <tr>
                <td class="text-center"><b>Podstawa prawna - informacje podstawowe</b></td>

                <td class="text-center"><b> Podstawa prawna - informacje szczegółowe</b></td>
              </tr>

              <tr>
                <td class="text-center"><b>3a</b></td>

                <td class="text-center"><b>3b</b></td>
              </tr>

              <tr>
                <td class="text-center">przepis ustawy</td>

                <td class="text-center">brak*</td>
              </tr>

              <tr>
                <td class="text-center">przepis ustawy</td>

                <td class="text-center">przepis aktu wykonawczego</td>
              </tr>

              <tr>
                <td class="text-center">przepis ustawy</td>

                <td class="text-center">przepis aktu wykonawczego<br />decyzja/uchwała/<br />decyzja/uchwała/</td>
              </tr>

              <tr>
                <td class="text-center">przepis ustawy</td>

                <td class="text-center">decyzja/uchwała/umowa – symbol</td>
              </tr>
            </table>

            <sup>* W przypadku braku aktu wykonawczego, decyzji, uchwały i umowy należy wpisać określenie „brak”.</sup>

            <br />

            <p>
              <b>Kol. 3a</b> Podstawa prawna - informacje podstawowe - należy podać w następującej kolejności: datę i
              tytuł oraz oznaczenie roku (numeru) i pozycji Dziennika Ustaw, w którym ustawa została opublikowana oraz
              oznaczenie przepisu ustawy będącego podstawą udzielenia pomocy (w kolejności: artykuł, ustęp, punkt,
              litera, tiret).
            </p>

            <p>
              <b>Kol. 3b</b> Podstawa prawna - informacje szczegółowe - jeżeli podstawą udzielenia pomocy był akt
              wykonawczy do ustawy, należy podać w następującej kolejności: nazwę organu wydającego akt, datę aktu i
              tytuł aktu oraz oznaczenie roku (numeru) i pozycji Dziennika Ustaw, w którym akt został opublikowany oraz
              przepis aktu wykonawczego będącego podstawą udzielenia pomocy (w kolejności: paragraf, ustęp, punkt,
              litera, tiret). Akt powinien być aktem wykonawczym do ustawy wskazanej w kol. 3a. W przypadku braku aktu
              wykonawczego będącego podstawą prawną udzielenia pomocy, należy wstawić określenie „brak”. Jeżeli podstawą
              udzielenia pomocy była decyzja, uchwała lub umowa, należy podać symbol określający ten akt; w przypadku
              decyzji - numer decyzji, w przypadku uchwały - numer uchwały, w przypadku umowy – numer, przedmiot oraz
              strony umowy. W przypadku braku decyzji, uchwały lub umowy będącej podstawą prawną udzielenia pomocy,
              należy wstawić określenie „brak”.
            </p>
          </li>
        </ol>

        <class-table />
      </div>
    </div>
  </w-spoiler>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import ClassTable from './ClassTable';

// @vuese
// Instrukcja wypełnienia tabeli w sekcji D formularza de minimis
// @Group formComponents
export default {
  components: {
    ClassTable,
    ...components
  }
};
</script>
